import React from 'react';
import { useParams } from 'react-router-dom';

import PipelineEngineConfigView from '../../PipelineEngineConfigView/PipelineEngineConfigView';
import PipelineStepList from '../../PipelineStepList/PipelineStepList';
import VersionHistoryTimeline from '../../../VersionHistoryTimeline/VersionHistoryTimeline';

import { usePipelineData } from '../../PipelineDataContext';

export const PipelineDetailTab = () => {
  const routeParams = useParams();
  const {
    pipeline,
    loading,
    error,
    pipelineSteps,
    removePipelineStep,
    latestPipelineDeployment,
    pipelineHistory,
    pipelineHistoryError,
    pipelineHistoryLoading,
  } = usePipelineData();

  return (
    <>
      {
        (pipelineSteps) ? (
          <div className="mb-2">
            <PipelineStepList
              pipeline={pipeline}
              error={error}
              items={pipelineSteps}
              areStepsLoading={loading}
              onDeleteStep={removePipelineStep}
            />

          </div>
        ) : null
      }
      <div className="mb-2">
        <VersionHistoryTimeline
          pipelineID={routeParams.id}
          timelineTitle={`Version History: ${routeParams.id}`}
          versionHistory={pipelineHistory}
          versionHistoryError={pipelineHistoryError}
          areVersionsLoading={pipelineHistoryLoading}
        />
      </div>
      {
        (
          latestPipelineDeployment?.engineConfig ? (
            <div>
              <PipelineEngineConfigView engineConfig={latestPipelineDeployment.engineConfig} />
            </div>
          ) : null
        )
      }
    </>
  )
};

export default PipelineDetailTab;
